import { MarketActivityIndicator } from '@market/react';

type LoadingScreenProps = {
  transparent?: boolean;
};

const LoadingScreen = ({ transparent }: LoadingScreenProps) => {
  return (
    <div
      className={`addons-loading-screen ${
        transparent ? 'addons-loading-screen-transparent' : ''
      }`}
    >
      <MarketActivityIndicator data-testid="addons-loading-indicator" />
    </div>
  );
};

export default LoadingScreen;
